import NavBar from '../components/shared/NavBar';
import Register from '../components/UserPage/Register';
import Footer from '../components/shared/Footer';
const RegisterPage = (props) => {

    return (
        <>
            <NavBar/>
            <Register/>
            <Footer/>
        </>
)}

export default RegisterPage;